
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const MobileIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M30.5 8C24.701 8 20 12.701 20 18.5V77.5C20 83.299 24.701 88 30.5 88H65.5C71.299 88 76 83.299 76 77.5V18.5C76 12.701 71.299 8 65.5 8H30.5ZM27 18.5C27 16.567 28.567 15 30.5 15H34C34 16.933 35.567 18.5 37.5 18.5H58.5C60.433 18.5 62 16.933 62 15H65.5C67.433 15 69 16.567 69 18.5V77.5C69 79.433 67.433 81 65.5 81H30.5C28.567 81 27 79.433 27 77.5V18.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 18.5C23.5 14.634 26.634 11.5 30.5 11.5L65.5 11.5C69.366 11.5 72.5 14.634 72.5 18.5V77.5C72.5 81.366 69.366 84.5 65.5 84.5H30.5C26.634 84.5 23.5 81.366 23.5 77.5V18.5Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M30.5 8C24.701 8 20 12.701 20 18.5V77.5C20 83.299 24.701 88 30.5 88H65.5C71.299 88 76 83.299 76 77.5V18.5C76 12.701 71.299 8 65.5 8H30.5ZM27 18.5C27 16.567 28.567 15 30.5 15H34C34 16.933 35.567 18.5 37.5 18.5H58.5C60.433 18.5 62 16.933 62 15H65.5C67.433 15 69 16.567 69 18.5V77.5C69 79.433 67.433 81 65.5 81H30.5C28.567 81 27 79.433 27 77.5V18.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 18.5C23.5 14.634 26.634 11.5 30.5 11.5L65.5 11.5C69.366 11.5 72.5 14.634 72.5 18.5V77.5C72.5 81.366 69.366 84.5 65.5 84.5H30.5C26.634 84.5 23.5 81.366 23.5 77.5V18.5Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
